import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/wowawards.png"
import MagicWithUs from "../../../components/inner-page/MagicWithUs"

export function Index() {
  return (
    <Layout
      title="WOW Awards Success with Premagic AI Photo Platform"
      description="Discover how WOW Awards enhanced their corporate award ceremony with AI-driven photo distribution and attendee engagement solutions by Premagic."
      metaImage={ThumbnailImage}
      keywords={[
        "WOW Awards case study, award ceremony photos, corporate awards events, award show technology, recognition event photos, award ceremony networking, corporate recognition events, award show photo sharing, employee recognition events, award ceremony management, corporate celebration photos, award event solutions, recognition ceremony technology, award show engagement, corporate awards platform",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "WOW Awards", url: "/case-study/wowawards/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "WOW Awards Success with Premagic AI Photo Platform",
            "description": "Discover how WOW Awards enhanced their corporate award ceremony with AI-driven photo distribution and attendee engagement solutions by Premagic.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.WOWAWARDS} />
    </Layout>
  )
}

export default Index
